export const toSlug = (str) => {
    if (typeof str === "string") {
      return str.toLowerCase().replace(/\s+/g, "-");
    } else {
      return str; 
    }
  };